import { Components, Theme } from '@mui/material';

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    fill: true;
  }
}

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: {},
  },
  variants: [
    {
      props: { color: 'fill' },
      style: ({ theme }: { theme: Theme }) => ({
        backgroundColor: theme.palette.surfaceContainer.high,
        color: theme.palette.primary.main,
        borderRadius: '11px',
        padding: '4px',
      }),
    },
  ],
};
